import { useDispatch } from 'react-redux';

import { NotificationActions } from 'app/store/data/notification';
import { MessageTypeEnum } from 'app/shared/enums';

export function useNotification() {
  const dispatch = useDispatch();
  return (type: MessageTypeEnum, content: string) =>
    dispatch(
      NotificationActions.showNotification({
        type,
        content,
      })
    );
}
